/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Zip/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromAggregate1 from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Zip({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/IntegrationsApplications/Content/SyncPatients/Content/SyncPatients/Content/PatientInternalCard/Zip"
  
}) {
let matchExternalZipValueData = fromData.useDataValue({ viewPath,
context: 'match',
path: 'external.zip',
})
let matchInternalZipValueData = fromData.useDataValue({ viewPath,
context: 'match',
path: 'internal.zip',
})
let aggregateData = fromAggregate.matchEquals(matchExternalZipValueData, matchInternalZipValueData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
let matchInternalZipValueData1 = fromData.useDataValue({ viewPath,
context: 'match',
path: 'internal.zip',
})
let constantData = 'N/A'
let aggregateData1 = fromAggregate1.any(matchInternalZipValueData1, constantData)
let matchExternalZipValueData1 = fromData.useDataValue({ viewPath,
context: 'match',
path: 'external.zip',
})
let matchInternalZipValueData2 = fromData.useDataValue({ viewPath,
context: 'match',
path: 'internal.zip',
})
let aggregateData2 = fromAggregate.matchEquals(matchExternalZipValueData1, matchInternalZipValueData2)
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Zip.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 text="ZIP"
 color={!aggregateData ? dtColorsRed900 : dtColorsNeutral900}
 data="match.external.zip"
 data="match.internal.zip"
 aggregate="/Data/aggregate.js matchEquals"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxxs}
 color={!aggregateData2 ? dtColorsRed900 : dtColorsNeutral900}
 size="small"
 data="match.internal.zip"
 data="'N/A'"
 aggregate="/Simple/Data/aggregate.js any"
 text={aggregateData1}
 data="match.external.zip"
 data="match.internal.zip"
 aggregate="/Data/aggregate.js matchEquals"
/>
</div>
{children}
</React.Fragment>)
}